export default function hamburgerMenu() {
  const ham = document.getElementById("hamburger-menu");// eslint-disable-line
  if (ham) {
    ham.addEventListener("click", () => {
      document.getElementById("masthead").classList.toggle("mb-active");// eslint-disable-line
    });
  }
}
